import { call, put, select, takeLatest } from 'redux-saga/effects'

import { selectAuthToken } from '@store/auth'
import {
  ISnapMetricsResponse,
  selectSnapMetricsLink,
  SnapMetricsActionTypes,
} from '@store/postCampaignReport'
import {
  fetchSnapMetrics,
  fetchSnapMetricsError,
  fetchSnapMetricsSuccess,
} from '@store/postCampaignReport/snapMetrics/actions'
import { networkRequest } from '@utils'
import { WatcherFunction } from '..'

export function* handleFetchSnapMetrics(action: ReturnType<typeof fetchSnapMetrics>) {
  const campaignId = action.payload

  try {
    const link = yield select(selectSnapMetricsLink, campaignId)
    const authToken: string = yield select(selectAuthToken)

    const metrics: ISnapMetricsResponse = yield call(
      networkRequest,
      link.method,
      link.href,
      undefined,
      authToken,
    )

    yield put(fetchSnapMetricsSuccess(metrics, campaignId))
  } catch (error) {
    yield put(fetchSnapMetricsError(error))
  }
}

function* watchFetchSnapMetrics() {
  yield takeLatest(SnapMetricsActionTypes.FETCH_REQUEST, handleFetchSnapMetrics)
}

export const snapMetricsSagas: ReadonlyArray<WatcherFunction> = [watchFetchSnapMetrics]
